import { render } from "./user_permissions.html?vue&type=template&id=16e2dec4&external"
import script from "./user_permissions.js?vue&type=script&lang=js&external"
export * from "./user_permissions.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__